module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch02"
    }
  }, [_c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("2")])])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("William Rubens pushed his hands slowly out from his sides as the two men in black ninja uniforms approached. Palms upward, he looked a little like an angel supplicating heaven; he waited patiently while one of them took a small device from his belt and waved it over Rubens’ body. About the size and shape of a flashlight, the device scanned Rubens’ clothes for circuits that might be used to defeat the next array of sensors, which were positioned in a narrow archway a few feet away. Satisfied that he carried nothing electronic, not even a watch, the ninjas nodded, and Rubens stepped forward through the detector.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_vm._v("The fact that Rubens had led the team that developed both the archway and the circuitry detectors did not exempt him from a thorough check, nor did the fact that, as the head of National Security Agency’s Combined Service Direct Operations Division—called simply Desk Three—Rubens was the number two man at the agency. If anything, it made the men work harder. The ninjas, as part of the NSA’s Security Division, ultimately worked for him. Anyone leaving Black Chamber—the massive multilevel subbasement facility bureaucratically known as Headquarters/Operations Building National Security Operational Control Center Secure Ultra Command, or OPS 2/B Level Black—was subject to a mandatory search. Had Rubens not been searched, these ninjas would have been summarily fired—after serving a one-year ")]), _c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_vm._v("sentence in the NSA detention center for dereliction of duty.")])]), _c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Cleared, Rubens continued from the basement levels of OPS 2 upstairs into the main operations building (known as OPS 2/A or just OPS 2), ran another gauntlet of security checks, and finally emerged outside where a Chevrolet Malibu waited to take him to his appointment in Washington. He slid into the front seat, nodded at the aide behind the wheel—an Army MP in civilian dress—and then leaned the seat back to rest as the driver pulled away from the curb.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Two other similarly nondescript vehicles, a panel van and a pickup truck, followed as they headed through Crypto City—known to the outside world as Fort Meade, if known at all—to get on the Baltimore–Washington Parkway. Both carried ninjas, whose dungarees and work shirts covered lightweight body armor; their vehicles were equipped with a variety of weapons that ranged from handguns to a pair of shoulder-launched Stingers, though the only things they would be tempted to use this afternoon were the M47 Dragon antitank weapons to cut through some of the traffic.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The trip from the Maryland suburbs where the NSA’s Puzzle Palace was located to the West Wing of the White House took roughly fifty-five minutes. Rubens spent it eyes closed, head back on the rest. His mind focused on a one-syllable nonsense word a yoga master had given him years before to conjure energy from the kundalini, a point somewhere near the lower spine that the master believed was the center of Rubens’ personal (and potentially transcendent) soul.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("By the time he arrived at the suite where the National Security Director was waiting with the president of the United States, the thirty-two-year-old mathematical genius and art connoisseur felt rested and refreshed. He also felt he had centered his often rambunctious energy and clamped hold of his ego.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("It was a good thing.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_vm._v("“The Wave Three mission was not authorized by Finding 302,” said National Security Director George Hadash as Rubens entered the Blue Room, a secure meeting room in sub")]), _c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_vm._v("level two of the building. “Losing that plane was a screwup.”")])]), _c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Rubens had known George Hadash since MIT, where he had been Hadash’s student in a graduate seminar on the use of science in international relations. He was used to the blunt blasts that substituted for proper greetings. “The target was discussed,” he told his onetime professor. “The protocol for Desk Three is that it is to operate autonomously once broad objectives are outlined. Wave Three was the best asset for the job, and it was under our control.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“The laser facilities were not important enough to risk that asset,” said Hadash.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I beg to differ. Contrary to the estimate from the Air Force Special Projects Office, the weapon is near an operational state. The CIA analysts believe it’s more advanced than our own Altrus. And there is no question that if it were operational, it could completely eliminate our satellite network over central Asia.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Hadash’s cheek twitched slightly, but he said nothing. The tic indicated to Rubens that he had made his point.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“We haven’t finished analyzing the data yet,” added the NSA official.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You’re going to have to explain to the president,” said Hadash.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Of course. If he wants to know.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Hadash gave him one of his most serious frowns, though Rubens hadn’t intended the comment as impertinent. The issue wasn’t plausible denial; compartmentalization was essential to successful espionage and covert action, which were Desk Three’s raison d’être.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“He’s not happy,” added Hadash. “The CIA has been all over this, and DOD is reminding him that the NSA has "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("no")]), _vm._v(" operational experience.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Not true,” said Rubens mildly. Silently congratulating himself on the earlier mention of the CIA—which would convey an open-minded neutrality in sharp contrast to the paranoid backbiting of his bitter intelligence service rivals—he took a seat on the couch. Hadash went to see if the president was ready to meet with him.")])]), _c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Both the CIA and the military had made plays to control Desk Three when it was created at the very start of President Jeffrey Marcke’s administration. Both were disappointed that the NSA was given primacy over the operation. CIA and military assets assigned to Desk Three, either on permanent “loan” or for temporary missions, were under Rubens’ direct command until released. This inevitably led to jealousy. While Rubens had foreseen this, it did present an ongoing problem that a man of lesser intellect and ability—in his humble opinion—would have had great trouble controlling.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The idea behind Desk Three was relatively simple in outline: New technologies such as satellite communications, miniaturized sensors, and remote-controlled vehicles could revolutionize covert action and direct warfare if used properly. The CIA, the NSA, the Air Force, the Navy, the Defense Intelligence Agency, the Army—all had expertise in specific areas but often could not work smoothly enough to leverage that expertise. It was no secret that the different groups charged with national security tended not to cooperate; any number of fiascoes, from the infamous "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Pueblo")]), _vm._v(" incident in the 1970s to the attack on the World Trade Center in 2001, could be at least partly blamed on this lack of coordination. And at a time when advances in technology were making all sorts of things possible, coordination was essential.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Desk Three’s evolution could be traced directly to the CIA’s former Division D, which had worked with the NSA in the 1950s and early ’60s planting sensors, stealing code-books, “turning” crypto experts—and assassinating foreigners, though this was not necessarily an NSA function. It was succeeded by the Special Collection Service, or SCS, which had essentially the same job, sans assassinations, which were outlawed by Congress following scandals in the 1970s. In both cases, the arrangement had the CIA working essentially as a contractor to the NSA; the SCS headquarters was not in Crypto City, and the field agents were never, or almost never, under direct NSA control.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_vm._v("Desk Three was different in that respect. It was intended ")]), _c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_vm._v("to represent a new, cutting-edge force to be used for not only collecting data but also, when the situation demanded, taking action “ad hoc” to meet objectives outlined by the president. It could tap into the full array of sensors maintained by the NSA, as well as the processed intercepts from those sensors and data analysis provided by all of the major intelligence agencies. It could call on its own air and space assets, including twelve Space Platforms, or ultralarge satellites that could launch customized eavesdropping probes, and eight remote-controlled F-47C robot planes that were arguably as capable as F-22s, with twice their range and about one-third of their size. Underwater assets gave Desk Three similar capabilities in the ocean. And a small team of agents, drawn from a variety of sources, gave it muscle.")])]), _c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Several agencies could have “run” Desk Three. Besides the CIA, the military’s USSOCOM, or U.S. Special Operations Command, had been a lead contender. But the NSA was chosen primarily because it was used to working with the high-tech gear that formed the backbone of the force concept. It also lacked some of the political entanglements that plagued the others.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("And, of course, it contained William Rubens.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Rubens was critical for several reasons beyond his outsize abilities. One was his friendship with Hadash. Another was his demonstrated skill at melding the disparate talents required for such an enterprise. Last but not least, he had conceived the concept. He personally wrote the report outlining it, well before Marcke’s election. Titled “Deep Black,” the report formed the blueprint for the operation and was still among the most highly classified documents in the government archives. The report title had become an unofficial name for Desk Three and its operations.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Rubens had long ago learned the difficult and distasteful lesson that sheer intelligence, culture, and genetics often mattered little in Washington, let alone in international affairs. The trick was to use these assets to maintain one’s position and thereby accomplish one’s goals. It took eternal vigilance and, perhaps, a touch of paranoia.")])]), _c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Rubens cleared his mind of external distractions, preparing himself to speak to the president. The room’s spartan furnishings made it look as if it belonged in a suburban tract house. A large video display sat behind a set of drapes where the picture window would be; otherwise the Blue Room was refreshingly devoid of high-tech gadgetry.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The door opened so abruptly Rubens barely had time to get to his feet as the president burst into the room, his hand thrust forward.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Billy, how are you?” said Marcke, playing the hail-fellow-well-met politico. Marcke was an inch taller than Rubens, who at six-four was not short; though in his early sixties, Marcke had an incredibly strong handshake and was said by the media to work with serious weights every afternoon.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Fine, sir.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The president released him and sat on the couch. Hadash and the secretary of defense, Art Blanders, entered belatedly. Both remained standing as the president leaned toward Rubens.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“How’s your boss?” asked Marcke.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Admiral Brown is still traveling, sir.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Vice Admiral Devlin Brown was a recent appointee to head the agency; he’d only been on the job for a few weeks. Rubens didn’t know Brown very well yet and, frankly, didn’t feel he’d be much of a force. It would take considerable ability to outperform the previous head of the NSA, in Rubens’ opinion—though if the opportunity presented itself, he certainly would be willing to try.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“All right, Billy,” said the president with the air of a favored uncle. “Tell us what happened to your airplane.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“The Ilyushin carrying the Wave Three magnetic data reader was targeted and shot down for reasons that remain unclear,” said Rubens. “We haven’t been able to identify where the MiG came from, which has complicated matters.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“How is that possible?” asked Blanders.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_vm._v("“We’re not omniscient,” said Rubens, managing a smile to keep his tone mild. The secretary had come to the admin")]), _c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_vm._v("istration after serving as CEO of a bank; it was difficult to take him seriously. “More than likely, it was a renegade PVO unit working out some sort of dispute over ‘fees.’ But the possibility that both the program and Wave Three itself have been compromised cannot be ruled out.”")])]), _c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“The lasers,” prompted Hadash.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Rubens launched into a quick but detailed summary of the Wave Three target, a data center related to the Russian-directed energy program.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“The Russian president denied there was a laser program in an interview with the BBC two weeks ago,” said Blanders.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The defense secretary was obviously interested in pushing DoD’s own laser program, but that wasn’t what motivated his comment. Rubens noted for future reference not only Blanders’ disdain for Alexsandr Kurakin, the Russian president, but also the hint that Blanders believed Marcke trusted Kurakin too much.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Perhaps you should bring it up with President Kurakin when you speak with him tomorrow,” added Blanders, alluding to the president’s biweekly telephone conference with the Russian president.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Doing that would inadvertently reveal quite a bit about the agency’s capabilities. But before Rubens could find a way to point this out semitactfully, Marcke cut him off.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Of course we’re not going to do that,” said the president. “Why show him our hand? The question is, will he ask about our aircraft?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I don’t believe so,” said Rubens.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The Wave Three compartment was rigged to self-destruct. According to protocol, none of the crew carried parachutes, though there was always a possibility that some had been carried anyway. Still, transmissions from the plane indicated that there had been no survivors.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“How can you be sure?” asked Blanders.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“The plane went down in a fairly remote area,” said Rubens. “We have one possible site that we’re keeping track of, and I have a team en route to survey it.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You didn’t see it on satellite?” Blanders asked.")])]), _c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Was that a criticism or a play for the comprehensive optical survey satellites, which would give the U.S. worldwide around-the-clock coverage? Rubens decided to interpret it as the latter.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“At the moment, we don’t have the resources for complete coverage,” said Rubens. “That would be very desirable. We did, however, pick up the explosion. We have data on the possible wreckage. Now we send someone there to look at it and make sure it was destroyed. Routine.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Hadash cleared his throat and began speaking in the slightly loud, slightly rushed tone that indicated he’d been rehearsing what he was to say for some time. “Given the controversy—”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“What controversy?” asked Rubens.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Given the controversy, I—we—feel there should be someone outside of Desk Three along.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“What?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“A neutral observer,” said Hadash. “Just to see the wreckage and make an unbiased report.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I don’t see why that would be necessary.” Rubens had been taken by surprise, but he labored now to hide it. More difficult to suppress was his anger at Hadash for failing to warn him.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He remembered his yoga mantra.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You don’t understand the political situation,” said Blanders.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“What political situation?” said Rubens.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The president put up his hand. “Billy, here’s the problem. The CIA wants to chop off your head. They have some friends on the Senate Intelligence Committee. The committee wants a briefing. George is going to give it to them based on what his personal investigator finds out. We need to be able to tell them definitively that the plane was completely wrecked, that there was no screwup.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Collins, the deputy director of operations over at the CIA. She was responsible for this. The bitch.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“There was no screwup,” said Rubens.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“It’s for your own good, William,” said Blanders.")])]), _c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Sir, we’re talking about something that’s at Level Five VRK,” said Rubens. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("VKR")]), _vm._v(" meant “very restricted knowledge”—the ultimate compartmentalization. “The team I’m sending in doesn’t even know about the technology, and they’re my top team.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“George’s man won’t know anything about it, either,” said Blanders. “What’s the big deal? Assuming the plane really was trashed.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The president’s gray eyes met Rubens’ and held them. Did he want Rubens out? Were they going to use this as a pretext to bag him?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“This isn’t a matter of trust, William,” said Hadash.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Rubens turned slowly toward him, deciding not to answer or debate the point—it was obviously already settled.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“If the politicians have any reason to run with this, they’ll compromise Desk Three and a great deal else,” Hadash added. “We don’t want that.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You have someone in mind?” said Rubens.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I do. His background has already been thoroughly checked. We can trust him. All he needs to do is confirm that the plane was destroyed. He won’t even know about the original mission, just that he’s to tell me what he sees.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“We don’t need more CIA people with axes to grind.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“He’s not. He has no axe to grind; he’s a complete outsider.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("It was possible, just possible, that Hadash was trying to help Rubens. A neutral observer could be trotted out for the Intelligence Committee and then turned out to pasture without jeopardizing anything.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("On the other hand, he could do serious damage gathering ammunition for someone like Collins.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Who is he?” asked Rubens.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Charles Dean,” said Hadash.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Dean? As in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Jihad")]), _vm._v(" Dean?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Hadash nodded.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_vm._v("Dean had been used on a cooperative venture with the French some months back. An ex-Marine, he had proven himself brave and resourceful. His background had been ")]), _c('a', {
    attrs: {
      "id": "page26"
    }
  }, [_vm._v("thoroughly checked, and he had proven able to keep his mouth shut.")])]), _c('a', {
    attrs: {
      "id": "page26"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He’d also been a bit slow to figure out what he’d gotten himself involved in. And the project had been opposed by Collins.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("So maybe Hadash was helping him out after all.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Or not. Collins might have feigned her opposition. Rubens would have to reconsider what had happened carefully and review Dean’s background.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Dean didn’t like the CIA—wasn’t that in the transcripts of his conversations?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A cover, perhaps.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“He’ll have to pass the security protocols,” said Rubens. “Briefing only on a need-to-know basis.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Of course,” said Hadash.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“If he passes our security tests, fine,” said Rubens.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Make sure your team waits to examine the plane’s wreckage until he does,” said the president. He rose, and as he did, he smiled broadly and his shoulders seemed to roll a bit. “So talk to me about wine, Billy. The French ambassador is upstairs and he’s always trying to one-up our California reds. Walk with me, gentlemen.”")])])]), _c('a', {
    attrs: {
      "id": "page26"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page26"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-85efc646","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781429954730_ch02.vue
// module id = 75
// module chunks = 0